import React, { useState, useMemo } from 'react'
import { dateCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { getApiTargetInfo, UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import { DatePicker, Select, Button, InputNumber, Input } from 'antd'
import { Label } from 'core/screen-util'
import {
  modifiedDateCol,
  modifierCol,
  utilityHeader,
  unitIdHeader,
  YNBooleanTypes,
} from 'core/HeaderColTypeProps'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import {
  getPJMUnitExtension,
  deletePJMUnitExtension,
  savePJMUnitExtension,
} from '../api/pgads'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

const title = 'PJM Unit Extension'

const PJMUnitExtension = ({ utilityNameMap, unitNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const withCriteria = (state, props, selectedUnits = []) => ({
    unitid: selectedUnits.map(u => u.unitId),
  })

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <table
      style={{
        width: '100%',
        borderSpacing: '10px',
        borderCollapse: 'inherit',
      }}
    >
      <tbody>
        <tr>
          <td style={{ minWidth: '100px' }}>
            <Label>Utility / Unit : </Label>
          </td>
          <td style={{ minWidth: '600px' }} colSpan="3">
            <UtilityUnitSelection
              utility={insertData.utility}
              unit={insertData.unitId}
              onUnitChange={value => {
                // setUtilityUnit(value)
                setInsertData({
                  ...insertData,
                  utility: value[0],
                  unitId: value[1],
                  unit: value[1].substr(3),
                })
              }}
            />
          </td>

          <td style={{ minWidth: '100px' }}>
            <Label>Effective Date : </Label>
          </td>
          <td>
            <DatePicker
              style={{ minWidth: '150px' }}
              allowClear={false}
              format="MM/DD/YYYY"
              value={insertData.effectiveDateMom}
              onChange={date => {
                setInsertData({
                  ...insertData,
                  effectiveDateMom: date,
                  effectiveDate: date.format('YYYY-MM-DD'),
                })
              }}
            />
          </td>
        </tr>
        <tr>
          <td>
            <Label>Cir WaterTemp : </Label>
          </td>
          <td>
            <Select
              style={{ width: '100px' }}
              value={insertData.cirWaterTemp}
              onChange={e => setInsertData({ ...insertData, cirWaterTemp: e })}
            >
              <Select.Option key="Y">Yes</Select.Option>
              <Select.Option key="N">No</Select.Option>
            </Select>
          </td>
          <td>
            <Label>Dry Bulb Temp : </Label>
          </td>
          <td>
            <Select
              style={{ width: '100px' }}
              value={insertData.dryBulbTemp}
              onChange={e => setInsertData({ ...insertData, dryBulbTemp: e })}
            >
              <Select.Option key="Y">Yes</Select.Option>
              <Select.Option key="N">No</Select.Option>
            </Select>
          </td>
          <td>
            <Label>Rel Humidity : </Label>
          </td>
          <td>
            <Select
              style={{ width: '100px' }}
              value={insertData.relHumidity}
              onChange={e => setInsertData({ ...insertData, relHumidity: e })}
            >
              <Select.Option key="Y">Yes</Select.Option>
              <Select.Option key="N">No</Select.Option>
            </Select>
          </td>
        </tr>
        <tr>
          <td style={{ width: '130px' }}>
            <Label>Intake Water Temp : </Label>
          </td>
          <td>
            <Select
              style={{ width: '100px' }}
              value={insertData.intakeWaterTemp}
              onChange={e =>
                setInsertData({ ...insertData, intakeWaterTemp: e })
              }
            >
              <Select.Option key="Y">Yes</Select.Option>
              <Select.Option key="N">No</Select.Option>
            </Select>
          </td>
          <td>
            <Label>Wet Bulb Temp : </Label>
          </td>
          <td>
            <Select
              style={{ width: '100px' }}
              value={insertData.wetBulbTemp}
              onChange={e => setInsertData({ ...insertData, wetBulbTemp: e })}
            >
              <Select.Option key="Y">Yes</Select.Option>
              <Select.Option key="N">No</Select.Option>
            </Select>
          </td>
          <td>
            <Label>Barometric Pressure : </Label>
          </td>
          <td>
            <Select
              style={{ width: '100px' }}
              value={insertData.barometricPressure}
              onChange={e =>
                setInsertData({ ...insertData, barometricPressure: e })
              }
            >
              <Select.Option key="Y">Yes</Select.Option>
              <Select.Option key="N">No</Select.Option>
            </Select>
          </td>
        </tr>
        <tr>
          <td>
            <Label>Test Duration : </Label>
          </td>
          <td>
            <InputNumber
              defaultValue={0}
              onChange={value =>
                setInsertData({ ...insertData, testDuration: value })
              }
            />
          </td>
          <td>
            <Label>Note 1 : </Label>
          </td>
          <td>
            <Input
              value={insertData.note1}
              onChange={e =>
                setInsertData({ ...insertData, note1: e.target.value })
              }
              maxLength={15}
            />
          </td>
          <td>
            <Label>Note 2 : </Label>
          </td>
          <td>
            <Input
              value={insertData.note2}
              onChange={e =>
                setInsertData({ ...insertData, note2: e.target.value })
              }
              maxLength={15}
            />
          </td>
        </tr>
        <tr>
          <td>
            <Label>Note 3 : </Label>
          </td>
          <td>
            <Input
              value={insertData.note3}
              onChange={e =>
                setInsertData({ ...insertData, note3: e.target.value })
              }
              maxLength={15}
            />
          </td>
          <td>
            <Label>Note 4 : </Label>
          </td>
          <td>
            <Input
              value={insertData.note4}
              onChange={e =>
                setInsertData({ ...insertData, note4: e.target.value })
              }
              maxLength={15}
            />
          </td>
          <td>
            <Label>Note 5 : </Label>
          </td>
          <td>
            <Input
              value={insertData.note5}
              onChange={e =>
                setInsertData({ ...insertData, note5: e.target.value })
              }
              maxLength={15}
            />
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
          </td>
          <td>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  )

  // const { utilityNameMap, unitNameMap } = props
  const headerWithFormatter = useMemo(
    _ =>
      PJMUnitExtensionHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )

  return (
    <CommonScreen
      withCriteria={withCriteria}
      withUnitSelection
      isAdminScreen
      title={title}
      header={headerWithFormatter}
      saveTask={savePJMUnitExtension}
      retrieveTask={getPJMUnitExtension}
      deleteTask={deletePJMUnitExtension}
      altBy={d => d.unitId}
      autoRetrieve={false}
      sortOptions={PJMUnitExtensionHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(PJMUnitExtension)

export const PJMUnitExtensionHeaders = [
  utilityHeader,
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'cirWaterTemp',
    display: 'Cir WaterTemp',
    sortOrder: 'asc',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({
    ident: 'dryBulbTemp',
    display: 'Dry Bulb Temp',
    isFiltered: true,
    ...toSelectionColProps(YNBooleanTypes),
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'relHumidity',
    display: 'Rel Humidity',
    isFiltered: true,
    ...toSelectionColProps(YNBooleanTypes),
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'intakeWaterTemp',
    display: 'Intake Water Temp',
    isFiltered: true,
    ...toSelectionColProps(YNBooleanTypes),
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'wetBulbTemp',
    display: 'Wet Bulb Temp',
    isFiltered: true,
    ...toSelectionColProps(YNBooleanTypes),
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'barometricPressure',
    display: 'Barometric Pressure',
    isFiltered: true,
    ...toSelectionColProps(YNBooleanTypes),
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'testDuration',
    display: 'Test Duration',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'note1',
    display: 'Note1',
    isFiltered: true,
    sortOrder: 'asc',
    width: 250,
    ellipsis: true,
  }),
  strCol({
    ident: 'note2',
    display: 'Note2',
    isFiltered: true,
    sortOrder: 'asc',
    width: 250,
    ellipsis: true,
  }),
  strCol({
    ident: 'note3',
    display: 'Note3',
    isFiltered: true,
    sortOrder: 'asc',
    width: 250,
    ellipsis: true,
  }),
  strCol({
    ident: 'note4',
    display: 'Note4',
    isFiltered: true,
    sortOrder: 'asc',
    width: 250,
    ellipsis: true,
  }),
  strCol({
    ident: 'note5',
    display: 'Note5',
    isFiltered: true,
    sortOrder: 'asc',
    width: 250,
    ellipsis: true,
  }),
  modifierCol,
  modifiedDateCol,
]
